import { Component } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"],
})
export class ForgotPasswordComponent {
  mobile: boolean = false;
  email: string = "";
  message: string = "";
  isSuccess: boolean = false;
  isLoading: boolean = false;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.parseUrlParameters();
  }

  private parseUrlParameters(): void {
    // 1. Yöntem: Angular ActivatedRoute ile Query Parametrelerini Dinleme
    this.route.queryParams.subscribe((params) => {
      if (params["email"]) {
        this.email = decodeURIComponent(params["email"]);
      }
      if (params["mobile"]) {
        this.mobile =
          decodeURIComponent(params["mobile"]) == "false" ? false : true;
      }
    });
  }

  sendResetLink() {
    if (!this.email) {
      this.message = "Lütfen geçerli bir e-posta adresi girin.";
      this.isSuccess = false;
      return;
    }
    this.isLoading = true;
    this.message = "";
    // Lokal NGINX proxy mantığınıza uygun URL (/api ile başlar)
    const obj = { email: this.email, mobile: this.mobile };
    this.authService.forgotPassword(obj).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.isSuccess = true;
        this.message =
          "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen gelen kutunuzu kontrol edin.";
      },
      (err) => {
        this.isLoading = false;
        this.isSuccess = false;
        // .NET 8.0 Rate Limiting'e takılırsa 429 döner
        if (err.status === 429) {
          this.message =
            "Çok fazla istek attınız. Lütfen 15 dakika sonra tekrar deneyin.";
        } else {
          this.message =
            err.error && err.error.message
              ? err.error.message
              : "E-posta gönderilirken bir hata oluştu.";
        }
      },
    );
  }
}
